import { render, staticRenderFns } from "./thanks-advisor.vue?vue&type=template&id=77e37442&"
import script from "./thanks-advisor.vue?vue&type=script&lang=js&"
export * from "./thanks-advisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports